import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

export const userSectionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const userSession = authService.getStoredUser('user')
  if (!userSession) return true

  // Only block user login page when a user is already logged in.
  if (route.routeConfig?.path === 'login') {
    return router.createUrlTree(['/'])
  }

  return true
}
